import {userCredentialsValidations} from "../helpers/messages";

export default {
    methods: {
        clearErrors(key) {
            if (!this.formErrors[key]) {
                return;
            }

            this.formErrors[key] = [];
        },

        validateUserCredentials() {
            this.formErrors = { firstName: [], lastName: []};
            userCredentialsValidations.firstName.forEach((validation) => {
                if (!validation.validationMethod(this.form.firstName)) {
                    this.formErrors.firstName.push(validation.text);
                }
            });

            userCredentialsValidations.lastName.forEach((validation) => {
                if (!validation.validationMethod(this.form.lastName)) {
                    this.formErrors.lastName.push(validation.text);
                }
            });

            Object.keys(this.formErrors).forEach((key) => {
                if (!this.formErrors[key].length) {
                    delete this.formErrors[key];
                }
            });
        },
    }
};